import routes from "routes";

export const getRouteNameByPath = (currentPath) => {
    // 모든 라우트를 순회하면서 검사
    for (const route of routes) {
        // 정확한 경로 매칭
        if (route.path === currentPath) {
            return route.name;
        }
        
        // children이 있는 경우 children도 검사
        if (route.children) {
            // 정확한 경로 매칭
            const exactMatch = route.children.find(child => child.path === currentPath);
            if (exactMatch) {
                return exactMatch.name;
            }
            
            // path parameter가 있는 경로 매칭
            const paramMatch = route.children.find(child => {
                if (child.path && child.path !== '*') {
                    const pathRegex = new RegExp(`^${child.path.replace(/:\w+/g, '(\\w+)')}$`);
                    return pathRegex.test(currentPath);
                }
                return false;
            });
            
            if (paramMatch) {
                return paramMatch.name;
            }
        }
    }
    
    return '알 수 없는 페이지';
}

export default getRouteNameByPath;
